import { get } from '@/lib/api/client'
import {
  type ApiResponse,
  type WebPage
} from '@/lib/api/types'

export class WebPagesService {

  /**
   * Get all web pages (unpaginated)
   */
  async getAllWebPages(): Promise<ApiResponse<WebPage[]>> {
    return await get<ApiResponse<WebPage[]>>(
      'website-pages/public/published-content'
    )
  }

  async getWebPageById(webPageId: string): Promise<ApiResponse<WebPage>> {
    return await get<ApiResponse<WebPage>>(
      `website-pages/public/${webPageId}/published-content`
    )
  }
}

// Export singleton instance
export const webPageService = new WebPagesService()

// Export default
export default webPageService